import { render, staticRenderFns } from "./ChannelStatistics.vue?vue&type=template&id=d6cbc522&scoped=true&"
import script from "./ChannelStatistics.vue?vue&type=script&lang=js&"
export * from "./ChannelStatistics.vue?vue&type=script&lang=js&"
import style0 from "./ChannelStatistics.vue?vue&type=style&index=0&id=d6cbc522&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6cbc522",
  null
  
)

export default component.exports